import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { isEmpty } from 'lodash';

import PageTitle from '../../components/PageTitle';
import Form from '../../components/Profile/Form';
import PasswordForm from '../../components/PasswordForm';
import Spinner from '../../components/Spinner';
import Snackbar from '../../containers/SnackbarContainer';
import ErrorDialog from '../../components/ErrorDialog';

class Profile extends PureComponent {
  componentDidMount() {
    this.props.me();
  }

  render() {
    const {
      profile,
      update,
      error,
      isFetching,
      clearError,
    } = this.props;

    return (
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <PageTitle> {profile.name} </PageTitle>
        </Grid>
        <Grid item xs={12}>
          { !isEmpty(profile) &&
            <Form
              editable
              user={profile}
              onSubmit={update}
              errors={error.errors}
            />
          }
        </Grid>
        <Grid item xs={12}>
          <PasswordForm
            user="employee"
            onSubmit={update}
            errors={error.errors}
            userId={profile.id}
          />
        </Grid>
        { isFetching && <Spinner /> }
        { (error.error || error.message) &&
          <ErrorDialog error={error.error || error.message} action={clearError} />
        }
        <Snackbar />
      </Grid>
    );
  }
}

export default Profile;

Profile.propTypes = {
  profile: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object.isRequired,
  update: PropTypes.func.isRequired,
  me: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/Profile/index.js